import React from 'react';

type Props = {
    title: string,
    icon: string,
    properties: {},
    type: string,
    // ─── M2: tenant-aware document metadata ───
    // Visibility drives the small lock/team icon next to the doc name.
    // IsOwner is reserved for future use (right-click "Share with Team"
    // will read it to decide whether to render that menu item).
    Visibility: string,
    IsOwner: boolean,
    OwnerEmail: string
};
const textBoxImg = require('../../assets/textbox.png').default;
const oran = '100%'

class ToolFileExplorer extends React.Component<Props> {
    imgRef

    constructor(props) {
        super(props);
        this.imgRef = React.createRef();
    };

    componentDidMount = () => {
    };
    onDragStart = (e: Object) => {
        const {type, Name, Date, Explorer, Thumb} = this.props;
        if (Thumb != undefined && Thumb != "") {
            var img = document.createElement("img");
            img.src = Thumb;
            e.dataTransfer.setDragImage(img, 80, 50);
        }
        e.dataTransfer.setData(
            'tool',
            JSON.stringify({
                Explorer,
                Name,
                Date
            })
        );
    };
    render = () => {
        const {icon, title, Name, Date, Thumb, Visibility, IsOwner} = this.props;
        const colClass = "pl-1   p-0 bg-gray-50 w-full text-gray-600 border  border-gray-200 text-sm outline-none whitespace-nowrap grid-cols-1";
        return (
            <div id="drag-with-image"
                 ref={this.imgRef}
                 style={{
                     margin: '0px'
                     , display: 'inline-table'
                 }}
                 thumb={Thumb}
                 onDragStart={this.onDragStart}
                 className="pl-1 hover:bg-blue-50 p-2 bg-gray-50 w-full text-gray-600 border-b border-gray-200 text-sm outline-none whitespace-nowrap"
                 draggable
                 onMouseLeave={evt => {
                     return;
                     if (evt.relatedTarget.id != "thumb-popup")
                         ;
                 }}
                 onMouseEnter={evt => {
                     return;
                     var loc = -100;
                     var rect = evt.target.getBoundingClientRect();
                     let st = evt.target.getAttribute('Thumb');
                     if (st != "" && st != null) {
                         var dd = $('.popup');
                         dd.attr("src", evt.target.getAttribute('Thumb'));
                         dd.css({
                             left: rect.x + loc, top: rect.y - (rect.height / 2),
                         });
                         dd.show();
                     } else {
                         $('.popup').css({
                             left: rect.x + loc, top: rect.y - (rect.height / 2)
                             , backgroundImage: "url(" + evt.target.getAttribute('Thumb') + ")",
                             backgroundSize: '100% 100%',
                             backgroundPosition: 'center',
                         }).hide();
                     }
                     $(this).on('mouseleave', function () {
                         $('.popup').hide();
                     });
                 }}
            >
                <div
                    className="thumb-cls"
                    style={{
                        height: '70px'
                    }}
                    onMouseOver={evt => {
                        evt.stopPropagation();
                    }}
                    onContextMenu={e => {
                        e.preventDefault();
                        this.props.setAnchorPoint({x: e.clientX, y: e.clientY});
                        this.props.setContextMenuState('opening');
                        this.props.setFileName(Name);
                        // ─── M2: pass visibility/owner so the menu can decide
                        // which actions (Share / Make Private) to render.
                        if (typeof this.props.setFileMetadata === 'function') {
                            this.props.setFileMetadata({
                                name: Name,
                                visibility: Visibility,
                                isOwner: IsOwner
                            });
                        }
                    }}
                >
                    <table
                        className="c"
                    >
                        <tbody>
                        <tr>
                            <td
                                className="cel"
                                style={{
                                    height: '5px'
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '0.85rem', lineHeight: '0.5rem'
                                    }}
                                >
                                    {/*
                                      ─── M2: visibility icon ───
                                      Tiny inline icon before the doc name. Renders only
                                      when Visibility is provided (legacy responses without
                                      this field show no icon, matching pre-M2 behavior).

                                      "account" → blue users icon = shared with team
                                      "private" → gray lock icon  = visible only to owner
                                      Non-owner team members see the team icon and gray
                                      colour (they're a viewer of someone else's share).
                                    */}
                                    {Visibility === 'account' && (
                                        <i
                                            className="fas fa-users"
                                            title={IsOwner
                                                ? "Shared with Team"
                                                : "Shared by " + (this.props.OwnerEmail || "team member")}
                                            style={{
                                                fontSize: '0.7em',
                                                marginRight: '6px',
                                                color: IsOwner ? '#3b82f6' : '#6b7280',
                                                verticalAlign: 'middle'
                                            }}
                                        />
                                    )}
                                    {Visibility === 'private' && IsOwner && (
                                        <i
                                            className="fas fa-lock"
                                            title="Private"
                                            style={{
                                                fontSize: '0.7em',
                                                marginRight: '6px',
                                                color: '#9ca3af',
                                                verticalAlign: 'middle'
                                            }}
                                        />
                                    )}
                                    {Name}
                                </div>
                            </td>
                            <td rowSpan="3"
                                className="super-centered"
                                align="left" valign="middle"
                            >
                                {Thumb &&
                                    <img src={Thumb}
                                         style={{
                                             width: oran,
                                             height: oran,
                                             minWidth: oran,
                                             maxHeight: oran
                                             ,
                                             border: 'solid',
                                             borderWidth: 'thin',
                                             borderColor: 'lightgrey',
                                             display: 'block',
                                             marginLeft: '0px',
                                             marginRight: '0px'
                                             ,
                                             cursor: 'zoom-in'
                                         }}
                                         onMouseDown={evt => {
                                             $('.popup').hide()
                                         }}
                                         onMouseLeave={evt => {
                                             var loc = -300;
                                             var rect = evt.target.getBoundingClientRect();
                                             var dd = $('.popup');
                                             dd.css({
                                                 left: rect.x + loc,
                                                 top: rect.y - (rect.height / 2),
                                                 transition: 'none',
                                                 display: 'block',
                                                 transform: 'scale(0,0)'
                                             });
                                         }}
                                         onMouseEnter={evt => {
                                             var loc = -300;
                                             var rect = evt.target.getBoundingClientRect();
                                             let st = Thumb;
                                             if (st != "" && st != null) {
                                                 var dd = $('.popup');
                                                 dd.attr("src", Thumb);
                                                 dd.css({
                                                     left: rect.x + loc,
                                                     top: rect.y - (rect.height / 2),
                                                     display: 'block'
                                                     ,
                                                     transform: 'scale(1,1)'
                                                     ,
                                                     transition: 'width 0.2s, height 0.2s, transform 0.2s'
                                                 });
                                                 $(this).on('mouseleave', function () {
                                                     var dd = $('.popup');
                                                     dd.css({
                                                         left: rect.x + loc,
                                                         top: rect.y - (rect.height / 2),
                                                         transition: 'none',
                                                         display: 'block'
                                                     });
                                                 });
                                             } else {
                                                 $('.popup').css({
                                                     left: rect.x + loc, top: rect.y - (rect.height / 2)
                                                     , backgroundImage: "url(" + evt.target.getAttribute('Thumb') + ")",
                                                     backgroundSize: '100% 100%',
                                                     backgroundPosition: 'center',
                                                     transition: 'none', display: 'block'
                                                 });
                                             }
                                             $(this).on('mouseleave', function () {
                                             });
                                         }}
                                    />
                                }
                            </td>
                        </tr>
                        <tr>
                            <td style={{height: '10px'}}>
                                <div
                                    onMouseOver={evt => {
                                        evt.stopPropagation();
                                    }}
                                    style={{fontSize: '0.7rem', lineHeight: '0.5rem'}}>
                                    {Date}
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };
}

export default ToolFileExplorer;
